export const copywrite = {
  main_title: "Arboretum Gambut Sukajadi",
  description: [
    //eslint-disable-next-line
    "Arboretum Gambut Sukajadi, sebuah inisiatif hijau yang digagas oleh PT Kilang Pertamina \
    Internasional Refinery Unit II, berdiri sebagai oase di tengah pesatnya pembangunan. \
    Program ini hadir sebagai bentuk komitmen perusahaan dalam melestarikan lingkungan, \
    khususnya ekosistem gambut yang rentan. Arboretum ini bukan sekadar kumpulan \
    tanaman, melainkan sebuah laboratorium alam yang berfungsi ganda sebagai paru-paru \
    kota dan pusat edukasi. Di sini, berbagai jenis tumbuhan, terutama spesies \
    asli yang beradaptasi dengan kondisi gambut, dirawat dan dilestarikan. Dengan \
    demikian, arboretum ini tidak hanya memperkaya keanekaragaman hayati, tetapi juga \
    menjaga keseimbangan ekosistem.",

    //eslint-disable-next-line
    "Lebih dari sekadar pelestarian, Arboretum Gambut Sukajadi juga berperan penting dalam meningkatkan \
    kesadaran masyarakat akan pentingnya ekosistem gambut. Melalui berbagai program edukasi \
    dan pelatihan, masyarakat diajak untuk lebih peduli terhadap lingkungan sekitar. Arboretum \
    ini menjadi tempat bagi generasi muda untuk belajar tentang alam dan pentingnya menjaga \
    kelestariannya. Dengan demikian, semangat pelestarian lingkungan dapat terus tumbuh \
    dan berkembang dari generasi ke generasi. Selain itu, arboretum ini juga menjadi \
    pusat penelitian yang memungkinkan para ilmuwan untuk menggali lebih dalam tentang \
    ekosistem gambut. Penelitian-penelitian ini diharapkan dapat menghasilkan data \
    dan informasi yang berharga untuk mendukung upaya pelestarian gambut di masa \
    depan.",
    //eslint-disable-next-line
    "Dalam konteks penilaian PROPER, keberadaan Arboretum Gambut Sukajadi menjadi poin plus bagi \
    PT Kilang Pertamina Internasional Refinery Unit II. Program ini menunjukkan komitmen \
    perusahaan dalam menerapkan prinsip-prinsip pembangunan berkelanjutan. Dengan berhasil \
    melestarikan ekosistem gambut, perusahaan tidak hanya berkontribusi pada pelestarian \
    lingkungan, tetapi juga mengurangi dampak perubahan iklim. Selain itu, keterlibatan \
    masyarakat dalam program ini juga menunjukkan bahwa perusahaan peduli terhadap \
    kesejahteraan sosial.",

    //eslint-disable-next-line
    "Arboretum Gambut Sukajadi adalah bukti nyata bahwa industri dan lingkungan dapat berjalan beriringan. \
    Melalui program ini, PT Kilang Pertamina Internasional Refinery Unit II telah \
    menunjukkan bahwa perusahaan besar dapat menjadi agen perubahan yang positif. \
    Dengan adanya Arboretum Gambut Sukajadi diharapkan dapat meraih keberhasilan \
    seperti site arboretum pendahulunya, Arboretum Gambut Marsawa.",
  ],

  flora_table_title: "Keanekaragaman Hayati Program Arboretum Sukajadi",
  bird_table_title: "Jumlah spesies Burung di Arboretum Sukajadi",
  mammals_table_title: "Jumlah spesies Mamalia di Arboretum Sukajadi",
  herpetofauna_table_title: "Jumlah spesies Herpetofauna di Arboretum Sukajadi",
  dragonfly_table_title: "Jumlah spesies Capung di Arboretum Sukajadi",
  butterfly_table_title: "Jumlah spesies Kupu-kupu di Arboretum Sukajadi",
};

export const flora = [
  {
    "No": 1,
    "spesies": "Ailanthus triphysa",
    "nama_lokal": "Mirip petai",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 2,
    "spesies": "Alphonsea javanica",
    "nama_lokal": "Setulang",
    "y2024": 0,
    "y2025": 4
  },
  {
    "No": 3,
    "spesies": "Alstonia pneumatophora",
    "nama_lokal": "Pulai rawa",
    "y2024": 26,
    "y2025": 26
  },
  {
    "No": 4,
    "spesies": "Aquilaria malaccensis",
    "nama_lokal": "Pelawar",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 5,
    "spesies": "Barringtonia acutangula",
    "nama_lokal": "Mangrove air tawar",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 6,
    "spesies": "Calamus sp.",
    "nama_lokal": "Rotan",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 7,
    "spesies": "Calanthe triplicata",
    "nama_lokal": "Anggrek bayi tidur",
    "y2024": 0,
    "y2025": 5
  },
  {
    "No": 8,
    "spesies": "Calophyllum inophyllum",
    "nama_lokal": "Nyamplung",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 9,
    "spesies": "Carallia brachiata",
    "nama_lokal": "Perepat hutan",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 10,
    "spesies": "Chionanthus ramiflorus",
    "nama_lokal": "Kayu malam",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": 11,
    "spesies": "Cleyera japonica",
    "nama_lokal": "Sakaki",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 12,
    "spesies": "Coffea arabica",
    "nama_lokal": "Kopi",
    "y2024": 6,
    "y2025": 6
  },
  {
    "No": 13,
    "spesies": "Coffea sp.",
    "nama_lokal": "Kopi hutan",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 14,
    "spesies": "Cyrtostachys renda",
    "nama_lokal": "Palem leher merah",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 15,
    "spesies": "Diospyros maritima",
    "nama_lokal": "Eboni laut",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 16,
    "spesies": "Diospyros sp.",
    "nama_lokal": "Arang-arang",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 17,
    "spesies": "Dipterocarpus sp.",
    "nama_lokal": "",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 18,
    "spesies": "Durio zibenthinus",
    "nama_lokal": "Durian hutan",
    "y2024": 1,
    "y2025": 2
  },
  {
    "No": 19,
    "spesies": "Dyera polyphylla",
    "nama_lokal": "Jelutung",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 20,
    "spesies": "Elaeocarpus achmadii",
    "nama_lokal": "-",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 21,
    "spesies": "Gluta renghas",
    "nama_lokal": "Rengas",
    "y2024": 4,
    "y2025": 4
  },
  {
    "No": 22,
    "spesies": "Gynotroches axillaris",
    "nama_lokal": "Mata keli",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 23,
    "spesies": "Koompassia malaccensis",
    "nama_lokal": "Kempas",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 24,
    "spesies": "Lindera sp.",
    "nama_lokal": "Medang-medangan",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 25,
    "spesies": "Macaranga sp.",
    "nama_lokal": "Mahang",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": 26,
    "spesies": "Macaranga triloba",
    "nama_lokal": "Mahang damar",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 27,
    "spesies": "Melicope ptelefolia",
    "nama_lokal": "Tenggek burung",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 28,
    "spesies": "Metroxylon sagu",
    "nama_lokal": "Rumbia",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 29,
    "spesies": "Nephelium glabrum",
    "nama_lokal": "Redan",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 30,
    "spesies": "Nephelium maingayi",
    "nama_lokal": "Ridan",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 31,
    "spesies": "Palaqium burchii",
    "nama_lokal": "Balam",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 32,
    "spesies": "Pandanus tectorius",
    "nama_lokal": "Pandan laut",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 33,
    "spesies": "Parashorea aptera",
    "nama_lokal": "Meranti batu",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 34,
    "spesies": "Parkia speciosa",
    "nama_lokal": "Petai",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 35,
    "spesies": "Shorea balangeran",
    "nama_lokal": "Blangeran",
    "y2024": 0,
    "y2025": 12
  },
  {
    "No": 36,
    "spesies": "Shorea sp.",
    "nama_lokal": "Meranti",
    "y2024": 7,
    "y2025": 7
  },
  {
    "No": 37,
    "spesies": "Shorea uliginosa",
    "nama_lokal": "Meranti daun lebar",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 38,
    "spesies": "Sindora sp.",
    "nama_lokal": "Sindur",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 39,
    "spesies": "Syzygium abulugense",
    "nama_lokal": "Kelat putih",
    "y2024": 4,
    "y2025": 4
  },
  {
    "No": 40,
    "spesies": "Syzygium lineatum",
    "nama_lokal": "Kelat",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 41,
    "spesies": "Syzygium oblatum",
    "nama_lokal": "Kelat jambu",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": 42,
    "spesies": "Syzygium palembanicum",
    "nama_lokal": "Kelat merah",
    "y2024": 2,
    "y2025": 2
  },
  {
    "No": 43,
    "spesies": "Tetramerista glabra",
    "nama_lokal": "Punak",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": 44,
    "spesies": "Uncaria acida",
    "nama_lokal": "Kekait",
    "y2024": 1,
    "y2025": 1
  }
];

export const birds = [
  {
    "No": 1,
    "spesies": "Aegithina tiphia",
    "nama_lokal": "Cipoh kacat",
    "y2024": 2,
    "y2025": 5
  },
  {
    "No": 2,
    "spesies": "Anthreptes malacensis",
    "nama_lokal": "Burung madu kelapa",
    "y2024": 2,
    "y2025": 4
  },
  {
    "No": 3,
    "spesies": "Cinnyris jugularis",
    "nama_lokal": "Burung madu sriganti",
    "y2024": 5,
    "y2025": 7
  },
  {
    "No": 4,
    "spesies": "Collocalia affinis",
    "nama_lokal": "Walet-sapi jari-bulu",
    "y2024": 0,
    "y2025": 3
  },
  {
    "No": 5,
    "spesies": "Copsychus saularis",
    "nama_lokal": "Kucica kampung",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 6,
    "spesies": "Dicaeum trigonostigma",
    "nama_lokal": "Cabai bunga-api",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 7,
    "spesies": "Dicrurus paradiseus",
    "nama_lokal": "Srigunting batu",
    "y2024": 3,
    "y2025": 5
  },
  {
    "No": 8,
    "spesies": "Eurystomus orientalis",
    "nama_lokal": "Tiong lampu biasa",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 9,
    "spesies": "Orthotomus atrogularis",
    "nama_lokal": "Cinenen belukar",
    "y2024": 1,
    "y2025": 2
  },
  {
    "No": 10,
    "spesies": "Passer montanus",
    "nama_lokal": "Burung gereja eurasia",
    "y2024": 8,
    "y2025": 13
  },
  {
    "No": 11,
    "spesies": "Psilopogon sp.",
    "nama_lokal": "Takur",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 12,
    "spesies": "Pycnonotus aurigaster",
    "nama_lokal": "Kutilang",
    "y2024": 3,
    "y2025": 6
  },
  {
    "No": 13,
    "spesies": "Pycnonotus goiavier",
    "nama_lokal": "Merbah cerucuk",
    "y2024": 3,
    "y2025": 7
  },
  {
    "No": 14,
    "spesies": "Pycnonotus plumosus",
    "nama_lokal": "Merbah belukar",
    "y2024": 3,
    "y2025": 5
  },
  {
    "No": 15,
    "spesies": "Strix leptogrammica",
    "nama_lokal": "Kukuk beluk",
    "y2024": 0,
    "y2025": 1
  }
];

export const mammals = [
  {
    "No": 1,
    "spesies": "Callosciurus notatus",
    "nama_lokal": "Bajing kelapa",
    "y2024": 6,
    "y2025": 8
  },
  {
    "No": 2,
    "spesies": "Macaca fascicularis",
    "nama_lokal": "Monyet ekor panjang",
    "y2024": 20,
    "y2025": 20
  },
  {
    "No": 3,
    "spesies": "Macaca nemestrina",
    "nama_lokal": "Beruk",
    "y2024": 10,
    "y2025": 10
  },
  {
    "No": 4,
    "spesies": "Presbytis melalophos",
    "nama_lokal": "Lutung simpai hitam sumatera",
    "y2024": 0,
    "y2025": 8
  },
  {
    "No": 5,
    "spesies": "Pteromyini sp.",
    "nama_lokal": "Tupai terbang",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 6,
    "spesies": "Sundasciurus lowii",
    "nama_lokal": "Bajing ekor pendek",
    "y2024": 0,
    "y2025": 3
  },
  {
    "No": 7,
    "spesies": "Sus scrofa",
    "nama_lokal": "Babi hutan",
    "y2024": 0,
    "y2025": 1
  }
];

export const herpetofauna = [
  {
    "No": 1,
    "spesies": "Chalcorana chalconota",
    "nama_lokal": "Kongkang kolam",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 2,
    "spesies": "Dendrelaphis caudolineatus",
    "nama_lokal": "Ular tambang bergaris",
    "y2024": 1,
    "y2025": 1
  },
  {
    "No": 3,
    "spesies": "Eutropis multifasciata",
    "nama_lokal": "Bengkarung",
    "y2024": 4,
    "y2025": 5
  },
  {
    "No": 4,
    "spesies": "Limnonectes macrodon",
    "nama_lokal": "Kodok batu",
    "y2024": 0,
    "y2025": 1
  }
];

export const dragonfly = [
  {
    "No": 1,
    "spesies": "Agriocnemis minima",
    "nama_lokal": "Capung-jarum kurcaci",
    "y2024": 6,
    "y2025": 6
  },
  {
    "No": 2,
    "spesies": "Anax sp.",
    "nama_lokal": "-",
    "y2024": 0,
    "y2025": 2
  },
  {
    "No": 3,
    "spesies": "Brachydiplax chalybea",
    "nama_lokal": "Capung-sambar dada-karat",
    "y2024": 0,
    "y2025": 3
  },
  {
    "No": 4,
    "spesies": "Camacinia gigantea",
    "nama_lokal": "Capung-jala raja",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 5,
    "spesies": "Ceriagrion cerinorubellum",
    "nama_lokal": "Capung-jarum ekor-jingga",
    "y2024": 0,
    "y2025": 3
  },
  {
    "No": 6,
    "spesies": "Nannophya pygmaea",
    "nama_lokal": "",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": 7,
    "spesies": "Neurothemis fluctuans",
    "nama_lokal": "Capung-jala kecil",
    "y2024": 6,
    "y2025": 6
  },
  {
    "No": 8,
    "spesies": "Orthetrum chrysis",
    "nama_lokal": "Capung-sambar perut-kait",
    "y2024": 3,
    "y2025": 3
  },
  {
    "No": "Jumlah",
    "spesies": "",
    "nama_lokal": "",
    "y2024": 18,
    "y2025": 27
  }
];

export const butterfly = [
  {
    "No": 1,
    "spesies": "Elymnias hypermnestra",
    "nama_lokal": "Kupu-kupu palem biasa",
    "y2024": 2,
    "y2025": 3
  },
  {
    "No": 2,
    "spesies": "Drupadia theda",
    "nama_lokal": "Kupu-kupu buket gelap",
    "y2024": 0,
    "y2025": 1
  },
  {
    "No": 3,
    "spesies": "Papilio demolion",
    "nama_lokal": "Kupu-kupu walet pita",
    "y2024": 0,
    "y2025": 2
  },
  {
    "No": 4,
    "spesies": "Graphium doson",
    "nama_lokal": "Kupu-kupu sayap segitiga biasa",
    "y2024": 0,
    "y2025": 2
  },
  {
    "No": 5,
    "spesies": "Eurema sp.",
    "nama_lokal": "Kupu-kupu alang kuning",
    "y2024": 0,
    "y2025": 3
  },
  {
    "No": 6,
    "spesies": "Graphium agamemnon",
    "nama_lokal": "Kupu-kupu sayap-segitiga berekor",
    "y2024": 0,
    "y2025": 2
  },
  {
    "No": 7,
    "spesies": "Zizina otis",
    "nama_lokal": "Kupu-kupu alang biru kecil",
    "y2024": 0,
    "y2025": 2
  }
];

export const data_count = {
  flora: [
    { x: "2024", y: 92 },
    { x: "2025", y: 119 },
  ],
  birds: [
    { x: "2024", y: 31 },
    { x: "2025", y: 62 },
  ],
  mammals: [
    { x: "2024", y: 37 },
    { x: "2025", y: 51 },
  ],
  herpetofauna: [
    { x: "2024", y: 5 },
    { x: "2025", y: 8 },
  ],
  dragonfly: [
    { x: "2024", y: 18 },
    { x: "2025", y: 27 },
  ],
  butterfly: [
    { x: "2024", y: 2 },
    { x: "2025", y: 15 },
  ],
};

export const total_species = {
  flora: [{ x: "2023", y: 72, yOffset: -25 }],
  birds: [
    { x: "2022", y: 22, yOffset: -25 },
    { x: "2023", y: 22, yOffset: -25 },
  ],
};

export const hre_index = {
  flora: [
    { x: "2024", h: 2.98, r: 7.74, e: 0.83, yOffset: 20 },
    { x: "2025", h: 3.21, r: 9.00, e: 0.85, yOffset: 20 }
  ],
  birds: [
    { x: "2024", h: 2.12, r: 2.62, e: 0.92, yOffset: 20 },
    { x: "2025", h: 2.42, r: 3.39, e: 0.89, yOffset: 20 }
  ],
  mammals: [
    { x: "2024", h: 1.08, r: 0.83, e: 0.78, yOffset: 20 },
    { x: "2025", h: 1.42, r: 1.53, e: 0.73, yOffset: 20 }
  ],
  herpetofauna: [
    { x: "2024", h: 0.5, r: 0.62, e: 0.72, yOffset: -20 },
    { x: "2025", h: 1.07, r: 1.44, e: 0.77, yOffset: -20 }
  ],		
  dragonfly: [
    { x: "2024", h: 0.33, r: 1.8, e: 0.17, yOffset: -20 },
    { x: "2025", h: 1.96, r: 2.12, e: 0.94, yOffset: -20 }
  ],		
  butterfly: [
    { x: "2024", h: 1.83, r: 0.94, e: 1.8, yOffset: -20 },
    { x: "2025", h: 1.90, r: 2.22, e: 0.98, yOffset: -20 }
  ],		
};
